import { composer } from '../../../../component-decorators/composer';
import s from '../../style.scss';
import { Box, Heading } from 'wix-style-react';
import * as React from 'react';
import { config } from '../../../../config';
import { SearchBoxContainer } from '../../../search-box';
import { EditorType } from '../../../..';
import { useConfigContext } from '../../../../config-context';
export var HomeHeader = composer()
    .withTranslation()
    .withExperiments()
    .compose(function () {
    // tslint:disable-next-line:react-hooks-nesting
    var locale = useConfigContext().locale;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s.homeHead },
            React.createElement("div", null,
                React.createElement(HomeTitle, null),
                React.createElement(Box, { height: '12px' }),
                React.createElement(SearchBoxContainer, { isInMenu: false, locale: locale })),
            React.createElement("img", { className: s.homeWithSearchImage, src: config.marketplaceStaticsUrl + "assets/images/home-illustrations/title-illustration-new.svg" }))));
});
var getHomePageTitle = function (experiments, t) {
    return config.editorType === EditorType.EDITORX
        ? t('home.page.editorX.title')
        : t('home.page.title');
};
var HomeTitle = composer()
    .withExperiments()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, experiments = _a.experiments;
    return (React.createElement("div", { className: "" + s.homeTitleWrapper },
        React.createElement("div", { className: s.homeTitle },
            React.createElement(Heading, { appearance: "H1", dataHook: "page-title", className: s.homeHeading }, getHomePageTitle(experiments, t))),
        React.createElement(Box, { width: 60 })));
});
//# sourceMappingURL=home-header.js.map